import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnDestroy } from '@angular/core';
import { ProgressGauge as progressGaugeInstance } from '@com-delta-omnichannel/mach-core-js';
import { ProgressGauge } from './models/progress-gauge.interfaces';

@Component({
  selector: 'idp-progress-gauge',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './progress-gauge.component.html',
  styleUrl: './progress-gauge.component.scss'
})
export class ProgressGaugeComponent implements AfterViewInit, OnDestroy {
  @Input() content: ProgressGauge = {} as ProgressGauge;
  @Input() disableAnimation = false;
  @Input() responsive = false;

  progressGauged!: progressGaugeInstance;

  ngAfterViewInit(): void {
    this.progressGauged = new progressGaugeInstance(this.content.options);
  }

  ngOnDestroy(): void {
    this.progressGauged?.destroy();
  }
}
